import * as tslib_1 from "tslib";
import updateIsExpanding from '../actions/updateIsExpanding';
import convertPersonaToRecipientPersonaProps from './convertPersonaToRecipientPersonaProps';
import processGetGroupInfoResult from 'owa-readwrite-recipient-well/lib/actions/processGetGroupInfoResult';
import { getGroupInfo } from 'owa-readwrite-recipient-well/lib/services/getGroupInfo';
export default function expandGroup(recipientWell, recipientToExpand, peoplePicker) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var groupResponse, expandedEmails;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    updateIsExpanding(recipientToExpand, true);
                    return [4 /*yield*/, getGroupInfo(recipientToExpand.persona.PersonaId, recipientToExpand.persona.ADObjectId, recipientToExpand.persona.EmailAddress)];
                case 1:
                    groupResponse = _a.sent();
                    updateIsExpanding(recipientToExpand, false);
                    expandedEmails = [];
                    processGetGroupInfoResult(expandedEmails, groupResponse);
                    return [2 /*return*/, convertPersonaToRecipientPersonaProps(expandedEmails)];
            }
        });
    });
}
//# sourceMappingURL=expandGroup.js.map